import React from 'react';
import Header from './components/Header';
import Social from './components/Social';
import About from './components/About';
import Accordions from './components/Accordions';
import TypeWriter from './components/TypeWriter';
import ImageSwiper from './components/ImageSwiper';
import Clients from './components/Clients';
import Share from './components/Share';
import Footer from './components/Footer';
import background from './images/bg.jpg';
import BottomSwiper from './components/BottomSwiper';

function App() {

  var domainUrl = 'https://anaelberlinsky.netlify.app/'
  var businessName = 'אנאל ברלינסקי';
  var businessDescription = 'קליניקה לקוסמטיקה ויופי'
  var phoneNumber = '+972549800918'
  var email = 'annael20@walla.co.il'
  var facebookUrl = 'https://www.facebook.com/annael.dahannew'
  var instagram = 'annaelberlinsky'
  var whatsapp = '+972549800918'
  var wazeUrl = 'https://www.waze.com/he/live-map/directions?to=ll.32.08457565%2C34.81528473'
  var days = " א' - ה'"
  var hours = '09:00 - 19:00'
  //קצת עליי
  //טיפולים בקליניקה
  //לקוחות ממליצים
  //icon
  //שם ותיאור


  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div className="bg-gray-50 w-full">
      <div className=" md:w-4/5 lg:max-w-[1152px] mx-auto shadow-2xl">
        <div className="object-cover">
          <div style={divStyle}>
            <Header
              businessName={businessName}
              businessDescription={businessDescription} />

            <Social
              businessName={businessName}
              businessDescription={businessDescription}
              phoneNumber={phoneNumber}
              email={email}
              facebookUrl={facebookUrl}
              instagram={instagram}
              whatsapp={whatsapp}
              wazeUrl={wazeUrl}
              domainUrl={domainUrl}
            />
            <About />

            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
            <TypeWriter
              businessName={businessName}
              businessDescription={businessDescription}
            />

          </div>
          <div style={divStyle}>
            <ImageSwiper />

            <BottomSwiper />

            <Clients
              whatsapp={whatsapp} />

            <Share domainUrl={domainUrl} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
